export default {
  user: null,
  roles: null,
  errors: null
};
